import { apiWrapper } from "@/services/api";

export const postFrames = async (sheet) => {
  try {
    const resp = await apiWrapper("POST", `sheets/${sheet.id}/frames`);
    return resp.data;
  } catch (err) {
    console.log('ERROR"" postFrame()');
    throw err;
  }
};
